const languages = [
  { name: "Spanish", link: "/languages/spanish" },
  { name: "Arabic", link: "/languages/arabic" },
  { name: "French", link: "/languages/french" },
  { name: "Italian", link: "/languages/italian" },
  { name: "German", link: "/languages/german" },
  { name: "Chinese", link: "/languages/chinese" },
  { name: "Brazilian", link: "/languages/brazilian-portuguese" },
  { name: "Japanese", link: "/languages/japanese" },
];

export const servicesLanguagesMap = {
  certified: {
    title: "Expert certified translation in 100+ languages",
    description:
      "We offer the most elite network of vetted ATA-certified native-language translators who specialize in official document translation for exceptional accuracy.",
    languages,
    exploreText: "Explore all",
  },
  enterprise: {
    title: "Professional content translation in 100+ languages",
    description:
      "We offer the most elite network of ATA-certified native-language translators vetted and experienced in your vertical and use case for exceptional accuracy across 100+ languages",
    languages,
    exploreText: "Explore all",
  },
  notarized: {
    title: "Notarized translations in 100+ languages",
    description:
      "We offer the most elite network of ATA-certified native-language translators.",
    languages,
    exploreText: "Explore all",
  },
  urgent: {
    title: "Urgent translations in 100+ languages",
    description:
      "We offer the most elite network of ATA-certified native-language translators available to translate immediately across time zones.",
    languages,
    exploreText: "Explore all",
  }
};
